import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { LogService } from '../../../_shared/log.service'
import { DocumentService } from '@app/_services/masters/document.service';
import { first } from 'rxjs/operators';
import { document } from '@app/_models/document';
import { Subject } from 'rxjs';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-document-master',
  templateUrl: './document-master.component.html',
  styleUrls: ['./document-master.component.css']
})
export class DocumentMasterComponent implements OnInit {
  document: document[];
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  @ViewChild('showModalDeleteBox', { read: TemplateRef }) showModalDeleteBoxTemplate: TemplateRef<any>;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  documentId: number;
  getresponse: any;
  delMessage: string;

  constructor(private modalService: NgbModal, config: NgbModalConfig, private eventService: LogService, private documentService: DocumentService) { }

  callRoute(dataValue) {
    this.eventService.emit<string>(dataValue);
  }

  passData(dataValue, data) {
    this.eventService.emit({ dataValue, data });
  }

  ngOnInit(): void {

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true
    };
    this.documentService.getDocument()
      .pipe(first())
      .subscribe(
        data => {
          console.log("document response---", data)
          this.document = data.respData;
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      )
  }
  deleteDocument(id) {
    this.documentId = id;
    this.modalService.open(this.showModalDeleteBoxTemplate);
  }

  deleteDoc() {
    this.documentService.deleteDocument(this.documentId)
      .pipe(first())
      .subscribe(
        data => {
          console.log("document response---", data)
          this.getresponse = data;

          if (this.getresponse.respMessage == "Success") {
            this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            this.delMessage = "Document Deleted Successfully."
            this.modalService.open(this.showModalBoxTemplate);
            this.documentService.getDocument()
              .pipe(first())
              .subscribe(
                data => {
                  console.log("document response---", data)
                  this.document = data.respData;
                  //this.dtTrigger.next();
                },
                error => {
                  console.log(error)
                }
              )
          }
          else if (this.getresponse.respMessage == "Failure") {
            this.delMessage=this.getresponse.respData;
             this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            this.modalService.dismissAll(this.showModalBoxTemplate);
          }
          //this.modalService.dismissAll(this.showModalDeleteBoxTemplate);

          // this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      )
  }
  refresh(): void {
    this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
    this.eventService.emit<string>('4');
  }


}
